import { render, staticRenderFns } from "./AgentBonus.vue?vue&type=template&id=3a585eeb&scoped=true"
import script from "./AgentBonus.vue?vue&type=script&lang=js"
export * from "./AgentBonus.vue?vue&type=script&lang=js"
import style0 from "./AgentBonus.vue?vue&type=style&index=0&id=3a585eeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a585eeb",
  null
  
)

export default component.exports